import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { CerrixInputComponent } from "../../atoms/cerrix-input/cerrix-input.component";
import { CerrixLabelComponent } from "../../atoms/cerrix-label/cerrix-label.component";
import { CerrixInputValidationMaxLengthDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-max-length.directive";
import { CerrixInputValidationErrorsDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-errors.directive";
import { CerrixInstructionsIconComponent } from "@app/shared/cerrix-instructions-icon/cerrix-instructions-icon.component";
import { CerrixInputValidationIsUrlDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-is-url.directive";

@Component({
    selector: "app-cerrix-hyperlink-url-input-group",
    imports: [
        CerrixInputComponent,
        CerrixLabelComponent,
        CerrixInstructionsIconComponent,
        CerrixInputValidationErrorsDirective,
        CerrixInputValidationMaxLengthDirective,
        CerrixInputValidationIsUrlDirective
    ],
    templateUrl: "./cerrix-hyperlink-url-input-group.component.html",
    styleUrl: "./cerrix-hyperlink-url-input-group.component.scss",
    encapsulation: ViewEncapsulation.None
})
export class CerrixHyperlinkUrlInputGroupComponent {
    @Input() placeholder: string = "";
    @Input() disabled: boolean = false;
    @Input() infoText: string = "";
    @Input() maxLength: number = 32767;
    @Input() name: string = "";
    @Input() type: string = "text";
    @Input() value: string = "";
    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
}
